import "leaflet/dist/leaflet.css";

import L from "leaflet";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import React from "react";

const icon = L.icon({
  iconSize: [25, 41],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
  iconUrl: "../assets/images/other/icon_map_pin.png",
});
export default function Map({ width = 1118, height = 306, widthFull = false }) {
  const AddressCo_Lat = 35.709956;
  const AddressCo_Lng = 51.476294;
  return (
    <MapContainer
      center={[AddressCo_Lat, AddressCo_Lng]}
      zoom={15}
      scrollWheelZoom={true}
      attributionControl={false}
      style={{
        width: `${widthFull ? "100%" : `${width}px`} `,
        height: `${height}px`,
        zIndex: "20",
      }}
      className="rounded-[10px]"
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker
        position={[AddressCo_Lat, AddressCo_Lng]}
        draggable={false}
        icon={icon}
      ></Marker>
    </MapContainer>
  );
}
